const Padlock = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M16.7131 7.35165C16.7131 5.06058 14.8558 3.2033 12.5647 3.2033H11.7618C9.47074 3.2033 7.61345 5.06058 7.61345 7.35165V11.0986H6.81055V7.35165C6.81055 4.61715 9.0273 2.40039 11.7618 2.40039H12.5647C15.2992 2.40039 17.516 4.61715 17.516 7.35165V11.0986H16.7131V7.35165Z"
        fill="#E5E5E5"
      />
      <path
        d="M16.1777 7.75299C16.1777 5.53582 14.3803 3.73845 12.1631 3.73845C9.94598 3.73845 8.14861 5.53582 8.14861 7.75299V10.5632H7.3457V7.75299C7.3457 5.09239 9.50255 2.93555 12.1631 2.93555C14.8237 2.93555 16.9806 5.09239 16.9806 7.75299V10.5632H16.1777V7.75299Z"
        fill="#E5E5E5"
      />
      <path
        d="M15.6296 7.89119C15.6296 5.6588 14.0775 4.48909 12.1629 4.48909C10.2483 4.48909 8.69626 5.6588 8.69626 7.89119V11.3607H8.00293V7.89119C8.00293 5.21232 9.86543 3.68066 12.1629 3.68066C14.4604 3.68066 16.3229 5.21232 16.3229 7.89119V11.3607H15.6296V7.89119Z"
        fill="#DAD5CD"
      />
      <path
        d="M4.80371 11.6332C4.80371 10.7463 5.52266 10.0273 6.40953 10.0273H17.9179C18.8047 10.0273 19.5237 10.7463 19.5237 11.6332V19.9299C19.5237 20.8167 18.8047 21.5357 17.9179 21.5357H6.40953C5.52266 21.5357 4.80371 20.8167 4.80371 19.9299V11.6332Z"
        fill="#FFCC5B"
      />
      <path
        d="M16.1782 10.0273H17.9179C18.8047 10.0273 19.5237 10.7463 19.5237 11.6332V19.9299C19.5237 20.8167 18.8047 21.5357 17.9179 21.5357H13.9033C13.9033 21.5357 15.7044 20.0095 16.4459 16.4506C17.1149 13.239 16.1782 10.0273 16.1782 10.0273Z"
        fill="#FDBC4B"
      />
      <path
        d="M12.2979 12.9717C13.3325 12.9717 14.1709 13.811 14.1709 14.8457C14.1708 15.4663 13.8681 16.0146 13.4033 16.3555C13.4062 16.371 13.4116 16.3863 13.4131 16.4023L13.583 18.2764C13.6114 18.5898 13.3645 18.8604 13.0498 18.8604H11.8135C11.4988 18.8604 11.2519 18.5898 11.2803 18.2764L11.4404 16.5098C10.8375 16.1985 10.4249 15.571 10.4248 14.8457C10.4248 13.811 11.2632 12.9717 12.2979 12.9717Z"
        fill="#464646"
      />
      <path
        d="M6.94434 19.5284V15.1124C6.94434 14.8168 7.18399 14.5771 7.47961 14.5771C7.77523 14.5771 8.01488 14.8168 8.01488 15.1124V19.5284C8.01488 19.824 7.77523 20.0637 7.47961 20.0637C7.18399 20.0637 6.94434 19.824 6.94434 19.5284Z"
        fill="#FFD769"
      />
      <path
        d="M8.01562 12.4362L8.01562 13.5067C8.01562 13.8023 7.77598 14.042 7.48035 14.042C7.18473 14.042 6.94508 13.8023 6.94508 13.5067L6.94508 12.4362C6.94508 12.1406 7.18473 11.9009 7.48035 11.9009C7.77598 11.9009 8.01562 12.1406 8.01562 12.4362Z"
        fill="#FFD769"
      />
    </svg>
  );
};

export default Padlock;
